module.exports = __webpack_public_path__ + "svg/delete.svg?b49d3a8cfec207cee48b1ab052b805a6";